const TEST_MODE = true;

export const BASE_URL = TEST_MODE
  ? 'https://de29.joinsaw.com'
  : 'https://joinsaw.com';
